

import apiWorker from '../apiWorker'

const totalConnections = {
    compile : () => apiWorker('post', `/v1/admin/total_connections`),
}

export default totalConnections;